// extracted by mini-css-extract-plugin
module.exports = {"content":"e_2r","opened":"e_3r","buttonIcon":"e_4r","buttonIconOpen":"e_5r","toggle":"e_6r","collapsible":"e_7r"};